import React, { useState, useEffect } from 'react';
import ProjectList from './components/ProjectList';
import CreateProject from './components/CreateProject';
import SubmissionsGrading from './components/SubmissionsGrading';
import useGroupProjectManagementStore from '@/stores/AdminStore/GroupProjectManagementStore';
import './GroupProjectManagement.css';

type TabType = 'list' | 'create' | 'submissions';

const GroupProjectManagement: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabType>('list');

  const {
    projects,
    submissions,
    fetchProjects,
    fetchSubmissions,
  } = useGroupProjectManagementStore();

  // Lazy load data based on active tab
  useEffect(() => {
    if (activeTab === 'list' && !projects) {
      fetchProjects();
    }
  }, [activeTab, projects, fetchProjects]);

  useEffect(() => {
    if (activeTab === 'submissions' && !submissions) {
      fetchSubmissions();
    }
  }, [activeTab, submissions, fetchSubmissions]);

  const tabs = [
    { id: 'list' as TabType, label: 'Project List' },
    { id: 'create' as TabType, label: 'Create Project' },
    { id: 'submissions' as TabType, label: 'Submissions & Grading' },
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'list':
        return <ProjectList />;
      case 'create':
        return <CreateProject />;
      case 'submissions':
        return <SubmissionsGrading />;
      default:
        return <ProjectList />;
    }
  };

  return (
    <div className="trainer-group-project-management">
      <div className="trainer-group-project-header">
        <div className="trainer-group-project-breadcrumb">
          <span>Content Management</span>
          <span className="trainer-group-project-separator">›</span>
          <span>Group Projects</span>
        </div>
        <div className="trainer-group-project-header-content">
          <div>
            <h1>Group Projects</h1>
            <p>Create and manage collaborative learning projects</p>
          </div>
          {activeTab === 'list' && (
            <button className="trainer-group-project-create-btn">+ Create Project</button>
          )}
        </div>
      </div>

      <div className="trainer-group-project-tabs">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`trainer-group-project-tab ${activeTab === tab.id ? 'trainer-group-project-tab-active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="trainer-group-project-content">{renderTabContent()}</div>
    </div>
  );
};

export default GroupProjectManagement;
